import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyCriteriaResources } from './useCriteriaResources';
import { getQueryKey as getQueryKeyCriteriaResourceById } from './useGetCriteriaResourceById';

// Config
import { uiConfig } from '../../../conf/criteriaResources';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_RESOURCE);

export const useUpdateCriteriaResource = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ update }) => Client.update(sessionToken, update.resourceId, update),
        onSuccess: (data, variables, context) => {
            updateCacheArray({
                queryKey: getQueryKeyCriteriaResources(),
                action: CACHE_ACTIONS.UPDATE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyCriteriaResourceById(data.resourceId)
            });
            onSuccessCb?.({ context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
